import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaDocumentosPendentes = (): TabelaColuna => ({
  Chave: 'documentosPendentesEnvio',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 100 }}>Doc. Pendentes</div>
})
